import React from "react";

import {Grid} from "@mui/material";
import QuestionsList from "./components/QuestionsList";
import Typography from "@mui/material/Typography";

const Questions: React.FC = () => {
    return (
        <>

            <Typography variant="h4" gutterBottom sx={{mb: 4, color: 'text.primary'}}>
                FAQ
            </Typography>
            <Grid
                container
                sx={{
                    flexDirection: "column",
                }}
            >
                <QuestionsList/>

            </Grid>

        </>
    );
};

export default Questions;